import React from "react";
import { useDataMan } from "../../hooks/useDataMan";
import { Spinner } from "@cmp-src/primitives/spinner";

export const DataManLoadMore: React.FC = () => {
  const { hasMoreData, onLoadMore, isLoadingMore } = useDataMan();

  if (!hasMoreData || !onLoadMore) {
    return null;
  }

  if (isLoadingMore) {
    return (
      <div className="flex w-full justify-center py-4 text-center">
        <Spinner size="sm" />
      </div>
    );
  }

  return (
    <div className="flex w-full justify-center py-3 text-center border-t border-neutral-200">
      <button
        type="button"
        onClick={onLoadMore}
        className="cursor-pointer font-semibold text-primary hover:text-primary-hover"
      >
        Load more
      </button>
    </div>
  );
};
